// @flow
import { connect } from 'react-redux';

import CompetitionsInternationalesNews from 'components/competitionsInternationales/competitionsInternationalesNews';
import { fetchTagArticle } from 'actions/tagArticleActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/competitionsInternationales/competitionsInternationalesNews';

export default connect(
  (state: StateType): StateProps => ({
    data: state.competitionsInternationalesState.data,
    status: state.competitionsInternationalesState.status,
    articlesStatus: state.tagArticleState.status,
    articles: state.tagArticleState.tagArticles,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticle: (slug: string) => dispatch(fetchTagArticle(slug, 1, 20))
  })
)(CompetitionsInternationalesNews);
